import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { notifySuccess, notifyError } from '../Notification';
import {  useLocation , useNavigate} from 'react-router-dom';
import { submitMYPSubjectSelectionForm } from '../api'; // Import the API function
import ThankYouModal from '../layout/ThankyouModal';

const MYPSubjectSelectionForm = () => {
  const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
  const location = useLocation();
  const navigate = useNavigate();
const child = location.state?.child;

  const [formData, setFormData] = useState({
    subjects: {
      group1: '',
      group2: [],
      group3: '',
      group4: '',
      group5: [],
      group6: '',
      compulsory: [],
      optional: []
    }
  });

  const handleCheckboxChange = (event, group, subject) => {
    const { checked } = event.target;
    setFormData((prevFormData) => {
      let subjects = prevFormData.subjects[group];
 
      if (group === 'group2' || group === 'group5' || group === 'compulsory' || group === 'optional') {
        subjects = checked
          ? [...subjects, subject]
          : subjects.filter((item) => item !== subject);
      } else {
        subjects = checked ? subject : '';
      }
      return {
        ...prevFormData,
        subjects: {
          ...prevFormData.subjects,
          [group]: subjects,
        },
      };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { subjects } = formData;
    if (
      !subjects.group1 ||
      subjects.group2.length === 0 ||
      !subjects.group3 ||
      !subjects.group4 ||
      subjects.group5.length === 0 ||
      !subjects.group6
    ) {
      notifyError('Please select the required subjects.');
      return;
    }

    const formattedData = {
      student_id: child.id,
      ...formData,
    };

    try {
      await submitMYPSubjectSelectionForm(formattedData);
      notifySuccess('Form submitted successfully!');
      setModalVisible(true);
    } catch (error) {
      notifyError('Error submitting form.');
      console.error('Error submitting form:', error);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h4" align="center" gutterBottom>
        MYP SUBJECT SELECTION FORM FOR MYP 4
      </Typography>
      <Paper elevation={3}>
        <Box p={2}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  SECTION A: SUBJECT SELECTION CRITERIA
                </Typography>
                <Typography variant="body1">
                  Students may select French OR Urdu but not both.
                </Typography>
                <Typography variant="body1">
                  Students are required to select ONE subject per group EXCEPT
                  FOR SCIENCES, in which more than one can be selected.
                </Typography>
                <Typography variant="body1">
                  Interdisciplinary & Personal Project in MYP 4 & 5 is
                  compulsory.
                </Typography>
                <Typography variant="body1">
                  ** Subject to approval by department.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">
                  Please (✓) the selected subjects
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="h6">
                  GROUP 1: LANGUAGE & LITERATURE
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group1 === 'English'}
                      onChange={(e) => handleCheckboxChange(e, 'group1', 'English')}
                    />
                  }
                  label="English"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">
                  GROUP 2: LANGUAGE ACQUISITION
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group2.includes('Urdu')}
                      onChange={(e) => handleCheckboxChange(e, 'group2', 'Urdu')}
                    />
                  }
                  label="Urdu"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group2.includes('French')}
                      onChange={(e) => handleCheckboxChange(e, 'group2', 'French')}
                    />
                  }
                  label="French"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">
                  GROUP 3: INDIVIDUALS & SOCIETIES
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group3 === 'History'}
                      onChange={(e) => handleCheckboxChange(e, 'group3', 'History')}
                    />
                  }
                  label="History"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group3 === 'Integrated Humanities'}
                      onChange={(e) => handleCheckboxChange(e, 'group3', 'Integrated Humanities')}
                    />
                  }
                  label="Integrated Humanities"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">GROUP 4: MATHEMATICS</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group4 === 'Standard'}
                      onChange={(e) => handleCheckboxChange(e, 'group4', 'Standard')}
                    />
                  }
                  label="Standard"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group4 === 'Extended'}
                      onChange={(e) => handleCheckboxChange(e, 'group4', 'Extended')}
                    />
                  }
                  label="Extended **"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">GROUP 5: SCIENCES</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group5.includes('Physics')}
                      onChange={(e) => handleCheckboxChange(e, 'group5', 'Physics')}
                    />
                  }
                  label="Physics"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group5.includes('Biology')}
                      onChange={(e) => handleCheckboxChange(e, 'group5', 'Biology')}
                    />
                  }
                  label="Biology"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group5.includes('Chemistry')}
                      onChange={(e) => handleCheckboxChange(e, 'group5', 'Chemistry')}
                    />
                  }
                  label="Chemistry"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">GROUP 6</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group6 === 'Visual Art'}
                      onChange={(e) => handleCheckboxChange(e, 'group6', 'Visual Art')}
                    />
                  }
                  label="Visual Art"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group6 === 'Design'}
                      onChange={(e) => handleCheckboxChange(e, 'group6', 'Design')}
                    />
                  }
                  label="Design"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.group6 === 'Physical & Health Edu'}
                      onChange={(e) => handleCheckboxChange(e, 'group6', 'Physical & Health Edu')}
                    />
                  }
                  label="Physical & Health Edu"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" align="center">
                  COMPULSORY
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.compulsory.includes('Personal Project')}
                      onChange={(e) => handleCheckboxChange(e, 'compulsory', 'Personal Project')}
                    />
                  }
                  label="Personal Project"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.compulsory.includes('Interdisciplinary')}
                      onChange={(e) => handleCheckboxChange(e, 'compulsory', 'Interdisciplinary')}
                    />
                  }
                  label="Interdisciplinary"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">
                  SECTION B: SUBJECT SELECTION CRITERIA
                </Typography>
                <Typography variant="body1">
                  *** Pakistan Studies & Islamyiat are compulsory for students
                  of national origin.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" align="center">
                  OPTIONAL SUBJECTS
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.optional.includes('Pak.Studies (GCE)')}
                      onChange={(e) => handleCheckboxChange(e, 'optional', 'Pak.Studies (GCE)')}
                    />
                  }
                  label="Pak.Studies (GCE)***"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.subjects.optional.includes('Islamyiat (GCE)')}
                      onChange={(e) => handleCheckboxChange(e, 'optional', 'Islamyiat (GCE)')}
                    />
                  }
                  label="Islamyiat (GCE)***"
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: "16px" }}
                  type="submit"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>

      </Paper>
      <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
    </Box>
  );
};

export default MYPSubjectSelectionForm;
